import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import ActionMessages from "../../../../common-components/ActionMessages";
import { PL_FONT } from "./plByProgramTheme";
import { MAX_RANGE_MONTHS, monthsInRange } from "./actualsVsForecastByDateRangeUtils";

const { RangePicker } = DatePicker;

const useStyles = makeStyles(() => ({
  wrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
    background: "#FFFFFF",
    borderRadius: 10,
    border: "1px solid #E2E8F0",
    padding: "8px 14px",
    width: "fit-content",
  },
  label: {
    fontSize: 10,
    fontWeight: 700,
    color: "#4A55A2",
    letterSpacing: "0.10em",
    textTransform: "uppercase",
    fontFamily: PL_FONT,
    whiteSpace: "nowrap",
  },
  hint: {
    fontSize: 11,
    color: "#6B7280",
    fontFamily: PL_FONT,
    whiteSpace: "nowrap",
  },
}));

export default function ActualsVsForecastByDateRangePicker({ startMonth, startYear, endMonth, endYear, onChange }) {
  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState(null);

  const value = [
    dayjs(`${startYear}-${String(startMonth).padStart(2, "0")}-01`),
    dayjs(`${endYear}-${String(endMonth).padStart(2, "0")}-01`),
  ];

  const handleChange = (range) => {
    if (!range || !range[0] || !range[1]) return;
    const nextStartMonth = range[0].month() + 1;
    const nextStartYear = range[0].year();
    const nextEndMonth = range[1].month() + 1;
    const nextEndYear = range[1].year();
    const count = monthsInRange(nextStartMonth, nextStartYear, nextEndMonth, nextEndYear);
    if (count > MAX_RANGE_MONTHS) {
      setErrorMsg(`Please select a range of ${MAX_RANGE_MONTHS} months or fewer (selected ${count}).`);
      return;
    }
    onChange({ startMonth: nextStartMonth, startYear: nextStartYear, endMonth: nextEndMonth, endYear: nextEndYear });
  };

  return (
    <>
      <div className={classes.wrap}>
        <span className={classes.label}>Date Range</span>
        <RangePicker
          picker="month"
          format="MMM YYYY"
          allowClear={false}
          value={value}
          onChange={handleChange}
        />
        <span className={classes.hint}>Max {MAX_RANGE_MONTHS} Months</span>
      </div>
      {errorMsg && (
        <ActionMessages type="error" message={errorMsg} isClosed={() => setErrorMsg(null)} />
      )}
    </>
  );
}
